import { render, staticRenderFns } from "./gallery-before-after.vue?vue&type=template&id=5f38fb06&"
import script from "./gallery-before-after.vue?vue&type=script&lang=js&"
export * from "./gallery-before-after.vue?vue&type=script&lang=js&"
import style0 from "./gallery-before-after.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports